import {Component, ElementRef, Input, ViewChild} from "@angular/core";
import {FileAttachment} from "../../../apis/backend";

@Component({
    selector: 'file-attachment-input',
    templateUrl: 'file-attachment-input.component.html'
})
export class FileAttachmentInputComponent {

    @Input('UploadHandler')
    public UploadHandler: (file: File) => Promise<any>;

    @ViewChild('NextFile')
    private _nextFileInput: ElementRef<HTMLInputElement>
    
    public UploadFile() {
        this.UploadHandler(this._nextFileInput.nativeElement.files[0])
            .then(() => {
                this._nextFileInput.nativeElement.value = '';
            });
    }
}